module.exports = __webpack_public_path__ + "img/a03595b.jpg";